import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

export const getErrorMessage = (flagAction) =>
  flagAction
    ? 'Не удалось установить индивидуальные даты'
    : 'Не удалось очистить индивидуальные даты';

const mutationFn = (data) => {
  return request.post(
    'Acceptance/add_acceptance_individual_dates',
    data,
    getErrorMessage(data.flagAction),
    'Error'
  );
};

export const useSetRoomsIndividualDatesMutation = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
